module.exports = __webpack_public_path__ + "img/sec2.2.88622e92.png";